import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import * as moment from 'moment';
import { environment } from 'environments/environment';
import * as _ from 'lodash';

@Component({
  selector: 'app-set-games-modal',
  templateUrl: './set-games-modal.component.html',
  styleUrls: ['./set-games-modal.component.scss']
})
export class SetGamesModal implements OnInit {
  eventName: string;
  seasonPreview: any;
  loading: boolean;
  imageURL = environment.URL_TEAM_IMAGES;
  teamDescription: any;
  teamName: any;
  teamImage: any;
  vendorId: any;

  events;
  totalValue = 0;
  gameCount = 0;

  selectedGamesArray = [];

  // flags
  isWeekendsSelected = false; 
  isWeekdaysSelected = false; 
  isCustomSelected = false; 
  flagString = '';

  constructor(
    public dialogRef: MatDialogRef<SetGamesModal>,
    private inventoryService: SsInventoryService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.eventName = data.eventName;
    this.teamImage = data.teamImage;
    this.teamName = data.teamName;
    this.teamDescription = data.teamDescription;
    this.buildDraft(data.events);
  }

  buildDraft(events) {
    _.each(events, (value) => {
      if (value.event_time === '00:00' || value.event_time === 'TBA' || value.event_time === 'TBD') {
        // Display TDB if invalid date
        value.event_time = 'TBD';
      } else {
        value.event_time = moment(value.event_time, 'hh:mm').format('LT');
      }
      let dateOb = moment(value.event_date);
      let day = dateOb.day();
      let isWeekend = (day === 6) || (day === 0);
      value['is_weekend'] = isWeekend;
      value['readable_date'] = dateOb.format('dddd MMM Do');
      if (!value['is_set']) {
        value['is_set'] = false;
      } else {
        this.selectedGamesArray.push(value)
        this.gameCount++;
      }
    });
    this.events = events;
    this.calculateTotal();
  }

  setOneEvent(event) {
    if (event['is_set'] == true) {
      event['is_set'] = false;
      this.removeSelected(event);
    } else {
      event['is_set'] = true;
      this.gameCount++;
      this.selectedGamesArray.push(event);
    }
    this.calculateTotal();
  }

  removeSelected(event) {
    this.selectedGamesArray.forEach((element, index) => {
      if (event.id == element.id) {
        this.selectedGamesArray.splice(index, 1);
        this.gameCount--;
      }
    })
  }

  calculateTotal() {
    let total = 0;
    _.each(this.selectedGamesArray, (value) => {
      if (value['is_set'] == true) {
        total = total + Number(value['face_value']);
      }
    })
    this.totalValue = total;
  }

  weekdays() {
    _.each(this.events, (value) => {
      if (value['is_weekend']) {
        value['is_set'] = false;
        this.removeSelected(value);
      } else {
        //dont set again
        if (value['is_set'] == false) {
          this.setOneEvent(value);
        }
      }
    });
    this.isWeekdaysSelected = true;
    this.isWeekendsSelected = false;
    this.isCustomSelected = false; 
    this.flagString = "WD";
  }

  weekends() {
    _.each(this.events, (value) => {
      if (value['is_weekend']) {
        //dont set again
        if (value['is_set'] == false) {
          this.setOneEvent(value);
        }
      } else {
        value['is_set'] = false;
        this.removeSelected(value);
      }
    });
    this.isWeekdaysSelected = false;
    this.isWeekendsSelected = true;
    this.isCustomSelected = false; 
    this.flagString = "WE";
  }

  custom(){
    this.isWeekdaysSelected = false;
    this.isWeekendsSelected = false;
    this.isCustomSelected = true; 
    this.reset(); 
    this.flagString = "MIX";
  }

  reset() {
    _.each(this.events, (value) => {
      value['is_set'] = false;
      this.removeSelected(value);
    })
    this.calculateTotal();
  }

  ngOnInit() {

  }

  close() {
    let data = {
      rawEvents: this.events,
      selectedGames: this.selectedGamesArray,
      total: this.totalValue,
      selectedGameCount: this.selectedGamesArray.length,
      flagString: this.flagString
    }
    this.dialogRef.close(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/set-games-modal/set-games-modal.component.ts